import { render } from "./CompanyAddressFields.vue?vue&type=template&id=25e65785"
import script from "./CompanyAddressFields.vue?vue&type=script&lang=js"
export * from "./CompanyAddressFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__